import ApiKeyProfileContainer from './ApiKeyProfile.container';

export default ApiKeyProfileContainer;
